import { createStore } from 'redux'
import reducer from './reducers'
import ReduxWindow from './window'

const store = createStore(
  reducer,
  (window as ReduxWindow).__REDUX_DEVTOOLS_EXTENSION__ && (window as ReduxWindow).__REDUX_DEVTOOLS_EXTENSION__()
)

export const getStore = () => store



// WEBPACK FOOTER //
// ./src/store.ts